import { DISPLAY } from "../constants.js";
import "./DeliveryFields.css";

export default function DeliveryFields({ doc, onChange, disabled }) {
  const isSelfHosted = doc.deliveryProfile === "self_hosted";

  return (
    <div>
      <label className="delivery-fields__label">Delivery</label>
      <select
        value={isSelfHosted ? "self_hosted" : "programmatic"}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="delivery-fields__select"
      >
        <option value="programmatic">Programmatic (Google / CM360)</option>
        <option value="self_hosted">Self-hosted (allows infinite loops)</option>
      </select>
      <p className="delivery-fields__hint">
        {isSelfHosted
          ? "Infinite loops allowed; no held-end-frame or 30s cap. May be rejected by Google/CM360."
          : `≤${DISPLAY.PROFILE.MAX_LOOPS} loops, ≤${DISPLAY.PROFILE.MAX_ANIMATION_S}s, held end frame, ≤${DISPLAY.PROFILE.MAX_ZIP_KB} KB — safe for ad servers.`}
      </p>
    </div>
  );
}